import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useServer } from '../contexts/ServerContext';
import { get, set } from 'idb-keyval';

const MAX_NOTE_LENGTH = 500;
const NOTE_KEY_PREFIX = 'notes_';

function getNoteKey(server, steamId) {
  return `${NOTE_KEY_PREFIX}${server}_${steamId}`;
}

export default function PlayerNote({ steamId }) {
  const { server } = useServer();
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    get(getNoteKey(server, steamId)).then(noteData => setNote(noteData || ''));
  }, [server, steamId]);

  const handleNoteSave = async () => {
    setSaving(true);
    await set(getNoteKey(server, steamId), note);
    setSaving(false);
  };

  return (
    <div className="flex-1 min-w-[320px] bg-gmod-lighter/80 rounded-2xl p-6 shadow-lg border border-gmod-lighterer">
      <div className="text-xl font-semibold text-theme-primary mb-4">Личная заметка</div>
      <textarea
        className="w-full p-3 rounded bg-gmod-lighter text-gmod-white resize-none text-base min-h-[160px]"
        rows={8}
        maxLength={MAX_NOTE_LENGTH}
        value={note}
        onChange={e => setNote(e.target.value)}
        placeholder="Ваша личная заметка об этом игроке..."
      />
      <div className="flex justify-between items-center mt-1 mb-2">
        <span className="text-xs text-gmod-white opacity-60">{note.length}/{MAX_NOTE_LENGTH}</span>
      </div>
      <div className="flex justify-end">
        <button
          className="px-5 py-2 bg-theme-primary text-gmod-white rounded font-semibold text-base"
          onClick={handleNoteSave}
          disabled={saving}
        >{saving ? 'Сохраняю...' : 'Сохранить'}</button>
      </div>
    </div>
  );
} 